import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from '../../src/i18n';
import { selectIsLoggedInState } from '../../store/selectors';

export function OBAppContainer({ pageProps, Component }) {
  return <Component {...pageProps} />;
}

const mapStateToProps = createStructuredSelector({
  isLoggedIn: selectIsLoggedInState(),
});

const withConnect = connect(mapStateToProps);

OBAppContainer.propTypes = {
  pageProps: PropTypes.any,
  Component: PropTypes.any,
  isLoggedIn: PropTypes.any,
};

export default compose(withConnect, withTranslation())(OBAppContainer);
